import axios from 'axios';


export const setAccessToken = (accessToken: string, refreshToken: string, keepLoggedIn: boolean) => {
  axios.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
 
  sessionStorage.setItem('accessToken', accessToken);
  sessionStorage.setItem('refreshToken', refreshToken);
  if (keepLoggedIn) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  }
};

export const getAccessToken = (): string | null => {
  return (
    localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken')
  );
};
export const getRefreshToken = (): string | null => {
  return (
    localStorage.getItem('refreshToken') || sessionStorage.getItem('refreshToken')
  );
};

export const clearAccessToken = () => {
  axios.defaults.headers.common.Authorization = null;
  sessionStorage.removeItem('accessToken');
  localStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
  localStorage.removeItem('refreshToken');

};
